import { render, staticRenderFns } from "./PositionsSelector.vue?vue&type=template&id=733253ba&scoped=true&"
import script from "./PositionsSelector.vue?vue&type=script&lang=js&"
export * from "./PositionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733253ba",
  null
  
)

export default component.exports